import { render, staticRenderFns } from "./2down.vue?vue&type=template&id=9c761eb8&"
import script from "./2down.vue?vue&type=script&lang=js&"
export * from "./2down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports